import * as React from "react";

function SvgIkonaKSubjektu(props) {
  return (
    <svg
      data-name="Vrstva 1"
      viewBox="0 0 400 400"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M133.29 118.99h32.75l-71.59 69.56H350v22.77H94.42L166 281.01h-32.75L50 199.94l83.29-80.95z" />
    </svg>
  );
}

export default SvgIkonaKSubjektu;

